import React from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";

// Clean instance with no interceptors. setupAxios() installs a request
// interceptor on the global axios that overwrites Authorization with the
// persisted session token, which would clobber the reset token from the email
// link whenever an agent still has a stale session in localStorage.
const resetClient = axios.create();

export default function changePassword(token, val) {
  const json = require("../../../config.json");
  const urlBase = json.urlBase;
  var url;
  var data;

  if (token) {
    url = urlBase + "/profile";
    data = { password: val};
    var config = {
      headers: {
        Authorization: "Bearer " + token.replace(/['"]+/g, ""),
      },
    };
    // console.log(token);
    // console.log(val);
    // console.log(url);
    // console.log(data);
    // console.log(config);

    return resetClient.patch(url,data,config);
  } else {
    return <Redirect exact from="/" to="/logout" />;
  }

}
